import React, { Fragment, useEffect, useState } from 'react';
type CountdownProps = {
  className?: string;
};
export function Countdown({
  className = ''
}: CountdownProps) {
  const [seconds, setSeconds] = useState(83027);
  useEffect(() => {
    const timer = window.setInterval(() => setSeconds(value => Math.max(0, value - 1)), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const units: Array<[string, number]> = [['hrs', Math.floor(seconds / 3600)], ['min', Math.floor(seconds % 3600 / 60)], ['sec', seconds % 60]];
  return <div className={`inline-flex items-center gap-2 ${className}`} aria-label="Time remaining on this offer" data-id="element-197" data-mp="1jhk9yn6s8agq">
      {units.map(([label, value], index) => <Fragment key={label} data-id="element-198" data-mp="1teg9i3epdm95" data-mpi={index}>
          {index > 0 && <span className="text-2xl font-bold text-orange-400" data-id="element-199" data-mp="1tddmi6ki43yi">:</span>}
          <span className="flex min-w-[68px] flex-col items-center rounded-lg bg-amber-400 px-3 py-2.5 leading-none" data-id="element-200" data-mp="38unr0wl8i5fu">
            <b className="text-3xl font-bold tabular-nums tracking-tight text-slate-950" data-id="element-201" data-mp="34sk1x55n72c3">
              {String(value).padStart(2, '0')}
            </b>
            <small className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-slate-800" data-id="element-202" data-mp="2c9zwkakohx7q">{label}</small>
          </span>
        </Fragment>)}
    </div>;
}